import { render, staticRenderFns } from "./ReqFarmacia.vue?vue&type=template&id=5034b0c0"
import script from "./ReqFarmacia.vue?vue&type=script&lang=js"
export * from "./ReqFarmacia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports